import Purchases from './Index.vue';

export default Purchases;



// WEBPACK FOOTER //
// ./src/pages/profile/views/purchases/index.ts